import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

export interface CounterProps
  extends React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>> {
  current: number
  max: number
}

export const Counter = React.memo(
  ({ current, max, className }: CounterProps) => {
    const { t } = useTranslation()
    if (!max) return null
    return (
      <span
        role="note"
        aria-label={t("General.CharactersUsed", {
          current,
          max
        })}
        className={classNames("counter", className)}
        data-testid="counter"
      >{`${current ?? 0}/${max}`}</span>
    )
  }
)
